import { TokenProvider, TokenResponse } from '@fluidx/office-fluid-types';
import { getOrigin } from '@fluidx/utilities';

const odspPushServiceScope = 'https://pushchannel.1drv.ms/pushchannel.readwrite.all';

// TODO: Task 4977404: Import getOdcStorageTokenScopes/getOdspSocketTokenScopes/prefetchOdcTokens from FF odsp-driver
// Once those functions are available from odsp-driver, can remove the three functions below and the const declaration above.
// Search for other places with that task number for places impacted.
export function getOdspStorageTokenScopes(siteUrl: string) {
  return [`${getOrigin(siteUrl)}/files.readwrite.all`];
}

export function getOdcStorageTokenScopes() {
  return ['onedrive.readwrite'];
}

export function getOdspSocketTokenScopes() {
  return [odspPushServiceScope];
}

// TODO: Task 4977404: Import getOdcStorageTokenScopes/getOdspSocketTokenScopes/prefetchOdcTokens from FF odsp-driver
// Once those functions are available from odsp-driver, uncomment the two-line block below.
// Search for other places with that task number for places impacted.
// // Re-export the three public functions that used to be in office-web-host and have since moved to the odsp driver
// // export { getOdspStorageTokenScopes, getOdcStorageTokenScopes, getOdspSocketTokenScopes } from '@fluidframework/odsp-driver'

/**
 * Prefetches the tokens required to host Fluid content stored in ODSP
 * @param tokenProvider An implementation of TokenProvider, which provides method for retrieving and caching tokens against scopes.
 * @param sites ODSP site URLs to prefetch tokens for.
 * @returns array of token promises for all prefetched resources
 */
export async function prefetchOdspTokens(tokenProvider: TokenProvider, sites: string[]): Promise<TokenResponse[]> {
  const tokenPromises = sites.map((site) => tokenProvider.getToken(getOdspStorageTokenScopes(site)));

  tokenPromises.push(tokenProvider.getToken(getOdspSocketTokenScopes()));

  return Promise.all(tokenPromises);
}

/**
 * Prefetches the tokens required to host Fluid content stored in ODC
 * @param tokenProvider An implementation of TokenProvider, which provides method for retrieving and caching tokens against scopes.
 * @param sites ODSP site URLs to prefetch tokens for.
 * @returns array of token promises for all prefetched resources
 */
export async function prefetchOdcTokens(tokenProvider: TokenProvider): Promise<TokenResponse[]> {
  return Promise.all([tokenProvider.getToken(getOdcStorageTokenScopes())]);
}

// cspell:ignore prefetch prefetched prefetches onedrive
